<template>
  <lf-card>
    <div class="flex space-x-2 py-4">
      <lf-scrollable-menu
        :scroll-length="200"
        :styling-options="{
          buttonsTransparent: true,
          offsetLeftClasses: '-left-12 top-2',
          offsetRightClasses: '-right-12 top-2',
        }"
      >
        <div
          v-for="funder in funders"
          :key="funder?.id"
          class="mx-1 flex cursor-pointer items-center space-x-3 rounded-5 px-3 py-1.5 font-medium"
          :class="
            funder.id === activeFilter.funder_id &&
            funder.product === activeFilter.product
              ? 'bg-primary/10 text-primary'
              : 'border border-gray-200 bg-white'
          "
          @click="
            $emit('update:activeFilter', {
              funder_id: funder.id,
              product: funder.product,
            })
          "
        >
          <img
            v-if="funder.icon?.file_url"
            :src="funder.icon?.file_url"
            class="h-10 w-10"
          />
          <span class="w-full truncate">
            {{ compact([funder?.full_name, funder?.product_name]).join(" • ") }}
          </span>
        </div>
      </lf-scrollable-menu>
    </div>
  </lf-card>
</template>
<script lang="ts">
interface FunderFilterRecord {
  id?: string;
  full_name?: string;
  icon?: IFunder["logo"];
  product: string;
  product_name: string;
}

export interface FilterData {
  funder_id?: string;
  product?: string;
}
</script>
<script setup lang="ts">
import compact from "lodash/compact";

import type { IFunder } from "@/models/funders";

defineProps<{
  funders: FunderFilterRecord[];
  activeFilter: FilterData;
}>();

defineEmits<{
  "update:activeFilter": [FilterData];
}>();
</script>
